import { Component, Output, EventEmitter } from "@angular/core";
import { Platform, NavController } from 'ionic-angular';
import { SecurityConfiguration } from '../security/security.configuration';

@Component({
    selector: 'slide-menu',
    styles: [`
            .container {
                position: absolute;
                z-index: 1000 !important;
                left: 0;
                width: 250px;
                height: 100%;
                top: -1px;
                box-shadow: 2px 0px 2px #bcbcbc;
                background: #303030;
                color: white;
            }
            ion-item {
                font-size: 12px;
                color:white;
                background: #303030;
            }
            ion-icon {
                margin-top: -3px;
                font-weight: bolder;
                font-size: inherit;
            }
            .help {
                font-size: 20px;
            }
            ion-row {
                border-bottom: 0.55px solid #555555;
                padding: 2px;
            }
            ion-row ion-col:last-of-type {
                font-size: 13px;
            }
            ion-footer{
                background: rgb(85,85,85);
                color: white;
            }
            p {
                font-size: 12px;
            }
            .copyright {
                font-size: 8px;
            }
            img {
                height: 3rem;
            }
            `],
    template: `
                <div class="container" id="menu">

                   <ion-grid>
                        <ion-row>
                            <ion-col col-1 text-right><ion-icon name="home" md="md-home"></ion-icon></ion-col>
                            <ion-col col-11  (tap)="display('home')">{{'Facility' | translate}}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col col-1 text-right><ion-icon class="help" name="help" md="md-help"></ion-icon></ion-col>
                            <ion-col col-11  (tap)="display('help')">{{'Help' | translate }}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col col-1 text-right><ion-icon name="call" md="md-call"></ion-icon></ion-col>
                            <ion-col col-11  (tap)="display('contact')">{{'Contact Johnson Controls' | translate}}</ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col col-1 text-right><ion-icon name="document" md="md-document"></ion-icon></ion-col>
                            <ion-col col-11  (tap)="display('aggrement')">{{'Agreement' | translate}}</ion-col>
                        </ion-row>
                   </ion-grid>
                   <ion-footer text-center>
                       <img src="assets/imgs/jci-logo-white.png">
                       <p>{{'Smart Connected Chiller Dashboard' | translate}}</p>
                       <p class="copyright">&copy; 2018 {{'Johnson Controls. All Rights Reserved' | translate}}</p>
                   </ion-footer>
                </div>
                
               
              `
})


export class SlideMenu {
    constructor(
        private platform: Platform,
        private navCtrl: NavController,
        private securityConfig: SecurityConfiguration
    ) { }

    public activeDiv: string = "home";

    @Output() typeEvent = new EventEmitter();

    display(type) {
        this.activeDiv = type;
        this.typeEvent.emit(this.activeDiv);
        // var x = document.getElementById("menu");
        // if (x.style.display == "none") {
        //     x.style.display = "block";
        // } else {
        //     x.style.display = "none";
        // }
    }
}


// WEBPACK FOOTER //
// ./src/components/slide-menu.component.ts